import React, { FC, MouseEvent } from 'react'
import { IconButton, BoxProps, Input } from '@chakra-ui/core'
import { css } from '@emotion/core'

export interface Props extends BoxProps {
  value?: number
  name: string
  minusAction: (event: MouseEvent<HTMLButtonElement>) => void
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const MinusAndText: FC<Props> = ({ value = 0, name, minusAction, onBlur, onChange }) => {
  const [quantity, setQuantity] = React.useState<number | string>(value)

  React.useEffect(() => {
    setQuantity(value)
  }, [value])

  return (
    <>
      <IconButton
        aria-label={`${name}-product-minus`}
        icon="minus"
        variant="outline"
        variantColor="primary"
        bg="transparent"
        borderColor="transparent"
        onClick={minusAction}
        fontSize="6"
        w="3.2rem"
        h="3.2rem"
        marginRight="0.4rem"
        isDisabled={value <= 0}
      />
      <Input
        type="number"
        css={css`
          /* Chrome, Safari, Edge, Opera */
          &::-webkit-outer-spin-button,
          &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }

          /* Firefox */
          &[type='number'] {
            -moz-appearance: textfield;
          }
        `}
        aria-label="quantity"
        flex="1"
        textAlign="center"
        p={0}
        fontSize="1.4rem"
        fontWeight="500"
        fontFamily="body"
        border="none"
        focusBorderColor="transparent"
        onBlur={onBlur}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          event.persist()

          const value = parseInt(event.target.value)
          const qty = isNaN(value) ? '' : value
          setQuantity(qty)

          onChange?.(event)
        }}
        onClick={(event: React.MouseEvent<HTMLInputElement>) => {
          event.stopPropagation()
        }}
        value={quantity}
      />
    </>
  )
}
